import React from "react";

const PrintIcon = (props) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>{props.title || "Print"}</title>
        <path
            d="M12.1605 9.57121V8.10952H4.50614V9.57121M12.1605 9.57121V12.6673H4.50614V9.57121M12.1605 9.57121H13.8333V5.52216H11.6378M4.50614 9.57121H2.83333V5.52216H5.02889M11.6378 5.52216H5.02889M11.6378 5.52216V3.33398H5.02889V5.52216"
            stroke={props.color || "#00549A"}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PrintIcon;
